import React, { Component } from 'react';

const EventManagement = () => {
	return ( <h1>Event Management</h1> );
}

export default EventManagement;